<template>
    <div class="time-picker">
        <div class="tit">{{ $t('filter') }}</div>

        <div class="tiems">
            <div class="input" :class="current === 0 ? 'active' : ''">
                <input id="start-time" v-model="startTime" readonly @click="tabClick(0)" />
            </div>
            <div class="line">-</div>
            <div class="input" :class="current === 1 ? 'active' : ''">
                <input id="end-time" v-model="endTime" readonly @click="tabClick(1)" />
            </div>
        </div>

        <van-datetime-picker v-show="showStartPicker" v-model="tempStartTime" type="date" :show-toolbar="false"
            :min-date="minDate" :max-date="maxDate" @change="onChangeStartDate" />

        <van-datetime-picker v-show="!showStartPicker" v-model="tempEndTime" type="date" :show-toolbar="false"
            :min-date="minDate" :max-date="maxDate" @change="onChangeEndDate" />


        <div class="common-btn ds-button-large" @click="bnt">{{ $t('MessageBox.Confirm') }}</div>
    </div>
</template>
  
<script>
import { Popup, DatetimePicker } from 'vant';
import 'vant/lib/popup/style';
import 'vant/lib/datetime-picker/style';

export default {
    components: {
        'van-popup': Popup,
        'van-datetime-picker': DatetimePicker
    },
    data() {
        return {
            endPicker: null,
            active: true,
            current: 0,
            showStartPicker: true,
            showEndPicker: false,
            startTime: this.formatDate(new Date()),
            endTime: this.formatDate(new Date()),
            tempStartTime: new Date(),
            tempEndTime: new Date(),
            minDate: new Date(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate()),
            maxDate: new Date()
        };
    },
    methods: {
        tabClick(i) {
            if (this.current === i) return;
            this.current = i;
            this.showStartPicker = !this.showStartPicker;
        },
        onChangeStartDate(picker) {
            const formatValue = (picker.getValues()[0] + '-' + picker.getValues()[1] + '-' + picker.getValues()[2])
            this.startTime = formatValue
        },
        onChangeEndDate(picker) {
            const formatValue = (picker.getValues()[0] + '-' + picker.getValues()[1] + '-' + picker.getValues()[2])
            this.endTime = formatValue
        },
        onStartConfirm(date) {
            this.startTime = this.formatDate(date);
            this.tempStartTime = date;
            this.showStartPicker = false;
            this.tempEndTime = new Date(this.startTime); // 更新结束时间的最小值
        },
        onEndConfirm(date) {
            this.endTime = this.formatDate(date);
            this.tempEndTime = date;
            this.showEndPicker = false;
            this.tempStartTime = new Date(this.minDate); // 重置开始时间的最大值
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        bnt() {
            this.endTime = this.addOneDay(this.endTime);

            this.$emit('time', {
                create_time_start: this.startTime,
                create_time_end: this.endTime
            });
        },
        addOneDay(dateStr) {
            // 将字符串解析为 Date 对象
            const date = new Date(dateStr);

            // 增加一天
            date.setDate(date.getDate() + 1);

            // 格式化日期为 YYYY-MM-DD
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
    },
    // watch: {
    //     startTime(newVal) {
    //         if (newVal) {
    //             this.tempEndTime = new Date(newVal); // 更新结束时间的最小值
    //         }
    //     },
    //     endTime(newVal) {
    //         if (newVal) {
    //             this.tempStartTime = new Date(this.minDate); // 重置开始时间的最大值
    //         }
    //     }
    // }
};
</script>
  
<style scoped lang="scss">
.common-btn {
    background: #1778FD;
}

.time-picker {
    width: 100vw;
    min-height: 60vh;
    border-radius: 20px 20px 0 0;
    padding: 20px;
    box-sizing: border-box;

    .tit {
        font-size: 18px;
        color: #000000;
        font-weight: 600;
        text-align: center;
    }

    .tiems {
        margin: 1rem 0 2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .input {
            width: 45%;

            input {
                box-sizing: border-box;
                width: 100%;
                border: 0;
                border-radius: 0;
                border-bottom: 2px solid #9A9A9A;
                text-align: center;
            }
        }

        .active {
            input {
                color: #1E74E7;
                border-color: #1E74E7;
            }
        }
    }
}

label {
    margin-right: 10px;
}

input {
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 200px;
    cursor: pointer;
}
</style>